import { useState, useEffect, useContext, useRef } from 'react'
import { useTranslation } from "react-i18next";

import './css/pop.css'

export default function TinyPopups({ setOpen, Open, onChange }) {

    const { t } = useTranslation();
    const [value, setvalue] = useState(false);
    
    function save() {

        onChange({ type: Open, value:value });
        setOpen(false);
    }

    return (
        <div tabindex="-1" className='tiny_pop Img'>
            
            <div className='tiny_body'>
                <h3>{t("task_type_5")}</h3>

                <div className='tiny_Inside'>
                    <label class="formInputBox focused">
                        <span>{t("task_right_answer")}</span>
                        <input onChange={(r) => setvalue(r.target.value)} name="textanser" />
                    </label>

                    <div style={{display:"flex", justifyContent:"end", gap:5, marginTop:20}}>
                        <button onClick={(d) => setOpen(false)} className='btn gray'>{t("cancel")}</button>
                        <button onClick={save} className='btn'>{t("save")}</button>
                    </div>
                </div>
            </div>

            

        </div>
    );
}